import { render, staticRenderFns } from "./extra-info.page.vue?vue&type=template&id=702317de&scoped=true&"
import script from "./extra-info.page.vue?vue&type=script&lang=js&"
export * from "./extra-info.page.vue?vue&type=script&lang=js&"
import style0 from "./extra-info.page.vue?vue&type=style&index=0&id=702317de&scoped=true&lang=scss&"
import style1 from "./extra-info.page.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702317de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VCheckbox,VDialog,VForm,VIcon})
